import { render } from "./ITable.vue?vue&type=template&id=c8391aec"
import script from "./ITable.vue?vue&type=script&lang=js"
export * from "./ITable.vue?vue&type=script&lang=js"

import "./ITable.vue?vue&type=style&index=0&id=c8391aec&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__